
import { defineComponent } from 'vue'
import { EpbText } from '../shared/epb-text'

export default defineComponent({
  name: 'ToolingPreviewNoResults',
  components: { EpbText },
  props: {
    imageAlt: {
      type: String,
      default: () => 'waiting to type a query',
    },
    imageSource: {
      type: String,
      default: () => require('../../assets/media/image/tooling/preview-empty-query.webp'),
    },
    title: {
      type: String,
      default: () => undefined,
    },
    smallImage: {
      type: Boolean,
      default: () => false,
    },
  },
  setup() {
    return {
      baseClass: 'epb-preview-no-results',
    }
  },
})
